var map = {
	"./LTC.svg": 722,
	"./V-round.svg": 723,
	"./account-check.svg": 724,
	"./achievement.svg": 725,
	"./add.svg": 726,
	"./aim.svg": 727,
	"./alarm.svg": 728,
	"./allow.svg": 395,
	"./angle-double-left.svg": 729,
	"./angle-left.svg": 174,
	"./angle-right.svg": 246,
	"./anticheat-circle.svg": 730,
	"./antichit-warning.svg": 731,
	"./arrow-down.svg": 282,
	"./arrow-left.svg": 326,
	"./arrow-right.svg": 732,
	"./arrow-up-right.svg": 733,
	"./arrow-up.svg": 734,
	"./attention.svg": 396,
	"./auth_discord.svg": 735,
	"./auth_facebook.svg": 736,
	"./auth_google.svg": 737,
	"./auth_steam.svg": 738,
	"./auth_vk.svg": 739,
	"./berserk.svg": 740,
	"./bitcoin.svg": 572,
	"./blog.svg": 741,
	"./bona.svg": 742,
	"./bonusWarning.svg": 743,
	"./bookmark-empty.svg": 563,
	"./bookmark-filled.svg": 564,
	"./bookmark.svg": 744,
	"./bulb.svg": 573,
	"./bullet-list.svg": 574,
	"./calendar.svg": 397,
	"./call.svg": 398,
	"./cam-circle.svg": 745,
	"./cam.svg": 746,
	"./cells.svg": 747,
	"./chart-down.svg": 748,
	"./chart.svg": 575,
	"./chat.svg": 201,
	"./chatvvv.svg": 560,
	"./checkmark-blue.svg": 749,
	"./checkmark-double-green.svg": 750,
	"./checkmark-green-plain.svg": 558,
	"./checkmark-green.svg": 399,
	"./checkmark-red.svg": 751,
	"./checkmark-white.svg": 752,
	"./checkmark.svg": 400,
	"./close-red.svg": 753,
	"./close.svg": 150,
	"./coins-gold.svg": 283,
	"./coins-in-round.svg": 754,
	"./coins-new.svg": 576,
	"./coins-payout.svg": 755,
	"./coins-yellow.svg": 756,
	"./coins.svg": 757,
	"./colorpicker.svg": 758,
	"./combined.svg": 759,
	"./copy.svg": 577,
	"./cost.svg": 760,
	"./create.svg": 761,
	"./credit-card-sponsor.svg": 762,
	"./credit-card.svg": 763,
	"./crown.svg": 764,
	"./dashboard.svg": 765,
	"./denied.svg": 248,
	"./devices/android.svg": 401,
	"./devices/ios.svg": 402,
	"./devices/mac.svg": 403,
	"./devices/windows.svg": 404,
	"./diamond.svg": 405,
	"./discord.svg": 766,
	"./dislike.svg": 767,
	"./done-circle.svg": 768,
	"./dots.svg": 406,
	"./double-check.svg": 407,
	"./download.svg": 769,
	"./duration.svg": 770,
	"./earn-w.svg": 771,
	"./earn.svg": 578,
	"./edit.svg": 579,
	"./email.svg": 772,
	"./enter.svg": 773,
	"./error-circle.svg": 580,
	"./error.svg": 774,
	"./euro.svg": 561,
	"./exit.svg": 562,
	"./eye-closed.svg": 775,
	"./eye.svg": 776,
	"./facebook.svg": 777,
	"./filter-arrow.svg": 319,
	"./filter.svg": 778,
	"./fixed.svg": 779,
	"./flag.svg": 780,
	"./gamepad.svg": 781,
	"./gamepad2.svg": 782,
	"./gear.svg": 581,
	"./gem.svg": 783,
	"./gift.svg": 784,
	"./giftAuth.svg": 785,
	"./globe.svg": 582,
	"./google.svg": 786,
	"./group.svg": 583,
	"./halfstar.svg": 787,
	"./heart-active.svg": 555,
	"./heart.svg": 315,
	"./hide.svg": 565,
	"./home.svg": 788,
	"./info-white.svg": 566,
	"./info.svg": 126,
	"./instagram.svg": 789,
	"./keyboard.svg": 790,
	"./kill.svg": 791,
	"./l-4-blocks-active.svg": 584,
	"./l-4-blocks.svg": 585,
	"./l-horizontal-active.svg": 586,
	"./l-horizontal.svg": 587,
	"./leaderboard.svg": 792,
	"./level.svg": 793,
	"./like.svg": 794,
	"./link-extra.svg": 408,
	"./link.svg": 409,
	"./list.svg": 795,
	"./location.svg": 796,
	"./lock-open.svg": 410,
	"./lock.svg": 797,
	"./mail-support.svg": 411,
	"./mail.svg": 567,
	"./marketplace-delete.svg": 327,
	"./max-loses.svg": 798,
	"./medal.svg": 588,
	"./menu.svg": 799,
	"./min-players.svg": 800,
	"./minus.svg": 801,
	"./money.svg": 802,
	"./money_2_sponsor.svg": 803,
	"./money_sponsor.svg": 804,
	"./my-account.svg": 805,
	"./new-rating.svg": 806,
	"./nominations.svg": 807,
	"./not-fixed.svg": 808,
	"./notifications.svg": 809,
	"./offerwall.svg": 810,
	"./other.svg": 811,
	"./overwolf.svg": 589,
	"./participants.svg": 812,
	"./paypal.svg": 813,
	"./pending.svg": 590,
	"./phone.svg": 814,
	"./player-empty.svg": 815,
	"./players.svg": 816,
	"./plus-white.svg": 591,
	"./plus.svg": 176,
	"./prize.svg": 817,
	"./protect.svg": 818,
	"./qiwi.svg": 819,
	"./question-mark-white.svg": 284,
	"./question-mark-yellow.svg": 556,
	"./rating.svg": 820,
	"./readed-mail.svg": 412,
	"./referral.svg": 821,
	"./refresh.svg": 413,
	"./reglament.svg": 822,
	"./round-currencies/coins.svg": 592,
	"./round-currencies/money.svg": 593,
	"./round-currencies/tickets.svg": 594,
	"./ru-card.svg": 823,
	"./sad.svg": 559,
	"./sale.svg": 595,
	"./santa-hat.svg": 414,
	"./sbp.svg": 824,
	"./search.svg": 825,
	"./security.svg": 826,
	"./send.svg": 827,
	"./settings.svg": 828,
	"./share.svg": 829,
	"./shield-user.svg": 830,
	"./shield.svg": 415,
	"./shop.svg": 416,
	"./shop_icon.svg": 831,
	"./sidebar.svg": 832,
	"./sign-in.svg": 394,
	"./smile-big.svg": 833,
	"./smile.svg": 834,
	"./star-gold.svg": 245,
	"./star-grey.svg": 318,
	"./star-round.svg": 835,
	"./star-small.svg": 836,
	"./star-v.svg": 837,
	"./star-violet.svg": 838,
	"./star-with-paddings.svg": 839,
	"./star.svg": 323,
	"./status.svg": 840,
	"./store.svg": 841,
	"./success.svg": 417,
	"./target.svg": 842,
	"./telegram-blue.svg": 568,
	"./telegram.svg": 202,
	"./tetris.svg": 843,
	"./thunder.svg": 418,
	"./ticket-big.svg": 844,
	"./ticket.svg": 845,
	"./tiktok.svg": 846,
	"./time-schedule.svg": 847,
	"./time.svg": 848,
	"./timer.svg": 849,
	"./top_sponsor.svg": 850,
	"./trash.svg": 324,
	"./triangle.svg": 569,
	"./trophy-w.svg": 851,
	"./trophy.svg": 596,
	"./twitch.svg": 852,
	"./twitter.svg": 853,
	"./twitter2.svg": 854,
	"./usd-card.svg": 855,
	"./user-white.svg": 597,
	"./user.svg": 419,
	"./v.svg": 856,
	"./verified.svg": 570,
	"./vk.svg": 857,
	"./wait.svg": 858,
	"./waiting.svg": 859,
	"./wallet-header.svg": 598,
	"./wallet.svg": 860,
	"./warning-2-red.svg": 599,
	"./warning-2.svg": 861,
	"./warning.svg": 203,
	"./webmoney.svg": 862,
	"./world.svg": 863,
	"./x2.svg": 864,
	"./youtube-white.svg": 865,
	"./youtube.svg": 866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74;